<p-card
    [class.bg-inactive]="!isActive()"
    pDraggable="dd"
    (onDragStart)="dragStart.emit(contact())"
    pDroppable="dd"
    (onDrop)="dragEnd.emit(contact().order ?? 0)"
>
    <div class="flex">
        <div class="user-info flex-1">
            <div>
                @if (isDoctor()) {
                    <i
                        [pTooltip]="'folderContact.doctorHoursTlp' | translate"
                        [ngClass]="{'pi': true, 'pi-clock': true, 'icons': true, 'text-success': opened(), 'text-danger': !opened() }"
                        (click)="showWorkingHours()"
                    ></i>
                } @else if (isActive()) {
                    @if (isAllowed['folderContact.update']()) {
                        @if (isPrimary()) {
                            <i
                                (click)="unmarkPrimary()"
                                [pTooltip]="'database.persons.contacts.primary' | translate"
                                class="pi pi-star-fill icons icons-hover text-danger"
                            ></i>
                        } @else {
                            <i
                                (click)="markAsPrimary()"
                                [pTooltip]="'database.persons.contacts.markAsPrimary' | translate"
                                class="pi pi-star icons icons-hover icons-non-primary text-danger"
                            ></i>
                        }
                    } @else {
                        <i
                            class="pi icons icons-non-primary text-danger"
                            [class]="isPrimary() ? 'pi-star-fill' : 'pi-star'"
                        ></i>
                    }
                }
            </div>
            <div class="flex-column align-items-center gap-small flex-1 pt-3">
                <app-avatar
                    size="xlarge" [initials]="contact().user | personInitials" [src]="contact().user.image"
                    [onlineStatus]="isActive() ? OnlineStatusEnum.Online : OnlineStatusEnum.Deactivated"
                ></app-avatar>
                <h3>{{ contact().user | formatPerson }}</h3>
                @if (contact().type === PersonContactTypeEnum.CONTACT) {
                    <div>
                        {{ !isDoctor() ? ('enum.contactType.' + contact().subType | translate) : contact().doctorSpecialization }}
                    </div>
                    <p-tag
                        [severity]="severity()"
                        [value]="!isDoctor()? contactRelation() : ('enum.contactType.doctor' | translate)"
                    />
                } @else if (contact().type === PersonContactTypeEnum.AUTHORIZATION) {
                    <div>{{ 'person.enum.authorization.' + contact().subType | translate }}</div>
                } @else if (contact().type === PersonContactTypeEnum.RESTRICTION) {
                    <div>{{ 'person.enum.restriction.' + contact().subType | translate }}</div>
                }
            </div>
            @if (isAllowed['folderContact.update']() || isAllowed['folderContact.delete']()) {
                <div>
                    <i [pTooltip]="'database.persons.contacts.settings.tooltip' | translate"
                        class="pi pi-cog icons icons-settings"
                        [ngClass]="{'text-secondary': !isActive(), 'text-help': isActive() }"
                        (click)="contextMenu.toggle($event)"
                    ></i>
                    <p-menu #contextMenu [model]="menuItems()" [popup]="true" appendTo="body"
                        styleClass="contact-card-context-menu"/>
                </div>
            }
            <div class="flex-column justify-content-center gap-small user-description">
                @if (contact().user.mobile) {
                    <div>
                        <i [class]="'pi pi-mobile ' + textClass()"></i>
                        {{ contact().user.mobile }}
                    </div>
                }
                @if (contact().user.phone) {
                    <div>
                        <i [class]="'pi pi-phone ' + textClass()"></i>
                        {{ contact().user.phone }}
                    </div>
                }
                @if (contact().user.email) {
                    <div>
                        <i [class]="'pi pi-envelope ' + textClass()"></i>
                        {{ contact().user.email }}
                    </div>
                }
                @if (contact().user.address) {
                    <div>
                        <i [class]="'pi pi-map-marker ' + textClass()"></i>
                        {{ contact().user.address | formatAddress }}
                    </div>
                }
                @if (isContact() && contact().data?.circumstance) {
                    <div>
                        <i [class]="'pi pi-sun ' + textClass()"></i>
                        {{ contact().data!.circumstance }}
                    </div>
                }
                @if (isContact() && contact().data?.info) {
                    <div>
                        <i [class]="'pi pi-info-circle ' + textClass()"></i>
                        {{ contact().data!.info }}
                    </div>
                }
                @if (isAuthorized() && contact().data?.dateOfAuthorization) {
                    <div>
                        <i [class]="'pi pi-calendar ' + textClass()"></i>
                        {{ 'database.persons.contacts.dateOfAuthorization' | translate }}: {{
                            contact().data!.dateOfAuthorization | shortDate
                        }}
                    </div>
                }
                @if (isAuthorized() && contact().data?.authorizationFrom) {
                    <div>
                        <i [class]="'pi pi-calendar ' + textClass()"></i>
                        {{ 'database.persons.contacts.authorizationFrom' | translate }}
                        {{ contact().data!.authorizationFrom | shortDate }}
                        {{ contact().data?.authorizationTo ? ('database.persons.contacts.authorizationTo' | translate) + ' ' + (contact().data?.authorizationTo | shortDate) : '' }}
                    </div>
                }
                @if (isAuthorized() && contact().data?.scopeOfAuthorization) {
                    <div>
                        <i [class]="'pi pi-bookmark ' + textClass()"></i>
                        {{ contact().data!.scopeOfAuthorization }}
                    </div>
                }
                @if (isDoctor()) {
                    <div>
                        <i [class]="'pi pi-building ' + textClass()"></i>
                        {{ contact().doctorWorkplace?.name }} {{ contact().user.icpOfDoctor }}
                    </div>
                }
            </div>
        </div>

        <p-divider layout="vertical"></p-divider>

        <div class="flex-column gap">
            @if (contact().user.email) {
                <app-button
                    icon="pi-envelope"
                    [severity]="severity()"
                    [pTooltip]="'database.persons.contacts.buttonTooltips.sendEmail' | translate"
                    [disabled]="!isActive()"
                    (clickEvent)="sendEmail()"
                ></app-button>
            }
            <!--            @if (isDoctor) {-->
            <!--                <app-button-->
            <!--                    icon="pi-comment"-->
            <!--                    [severity]="severity"-->
            <!--                    [pTooltip]="'database.persons.contacts.buttonTooltips.openChat' | translate"-->
            <!--                    [disabled]="!isActive"-->
            <!--                ></app-button>-->
            <!--                <app-button-->
            <!--                    icon="pi-send"-->
            <!--                    [severity]="severity"-->
            <!--                    [pTooltip]="'database.persons.contacts.buttonTooltips.sendNotification' | translate"-->
            <!--                    [disabled]="!isActive"-->
            <!--                ></app-button>-->
            <!--            }-->
            @if (contact().user.phone) {
                <app-button
                    icon="pi-phone"
                    [severity]="severity()"
                    [pTooltip]="'database.persons.contacts.buttonTooltips.callLandline' | translate"
                    [disabled]="!isActive()"
                    (clickEvent)="callPhone(contact().user.phone ?? null)"
                ></app-button>
            }
            @if (contact().user.mobile) {
                <app-button
                    icon="pi-mobile"
                    [severity]="severity()"
                    [pTooltip]="'database.persons.contacts.buttonTooltips.callOnMobile' | translate"
                    [disabled]="!isActive()"
                    (clickEvent)="callPhone(contact().user.mobile ?? null)"
                ></app-button>
            }
            @if (contact().user.address) {
                <app-map-link
                    [data]="contact().user.address"
                    [severity]="severity()"
                    [onlyTextClass]="false"
                    tooltip="database.persons.contacts.buttonTooltips.showMap"
                ></app-map-link>
            }
            <!-- <app-button icon="pi pi-calendar" [severity]="severity"
                [pTooltip]="'database.persons.contacts.buttonTooltips.planMeeting' | translate"
                [disabled]="!isActive"></app-button> -->
        </div>
    </div>
</p-card>
